module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui tab top attached",
    attrs: {
      "id": "settings-list-container"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "simple"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "passcode"
    },
    domProps: {
      "value": _vm.passcode
    },
    on: {
      "change": _vm.load_id
    }
  }), _c('div', {
    staticClass: "magic label"
  }, [_vm._v("passcode")])]), _c('li', {
    staticClass: "simple"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": "John"
    },
    domProps: {
      "value": _vm._s(_vm.name)
    },
    on: {
      "change": _vm.update_user,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "magic label"
  }, [_vm._v("name")])]), _c('li', {
    staticClass: "simple"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": "john@example.com"
    },
    domProps: {
      "value": _vm._s(_vm.email)
    },
    on: {
      "change": _vm.update_user,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "magic label"
  }, [_vm._v("email")])]), _c('li', {
    staticClass: "simple"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": "03 1234 5678"
    },
    domProps: {
      "value": _vm._s(_vm.phone)
    },
    on: {
      "change": _vm.update_user,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "magic label"
  }, [_vm._v("phone")])]), _c('li', {
    staticClass: "color-container"
  }, [_c('ul', {
    staticClass: "color-list"
  }, [_c('li', {
    staticClass: "color-choice color-1",
    on: {
      "mousedown": function($event) {
        _vm.set_color(1)
      }
    }
  }, [_c('i', {
    staticClass: "ui checkmark icon"
  })]), _c('li', {
    staticClass: "color-choice color-2",
    on: {
      "mousedown": function($event) {
        _vm.set_color(2)
      }
    }
  }, [_c('i', {
    staticClass: "ui checkmark icon"
  })]), _c('li', {
    staticClass: "color-choice color-3",
    on: {
      "mousedown": function($event) {
        _vm.set_color(3)
      }
    }
  }, [_c('i', {
    staticClass: "ui checkmark icon"
  })]), _c('li', {
    staticClass: "color-choice color-4",
    on: {
      "mousedown": function($event) {
        _vm.set_color(4)
      }
    }
  }, [_c('i', {
    staticClass: "ui checkmark icon"
  })]), _c('li', {
    staticClass: "color-choice color-5",
    on: {
      "mousedown": function($event) {
        _vm.set_color(5)
      }
    }
  }, [_c('i', {
    staticClass: "ui checkmark icon"
  })])]), _c('div', {
    staticClass: "magic label"
  }, [_vm._v("color")])]), _c('li', {
    staticClass: "simple submit",
    on: {
      "click": _vm.update_user
    }
  }, [_c('h1', [_vm._v("submit")])]), _c('li', {
    staticClass: "simple users"
  }, [_c('ul', {
    staticClass: "user-list"
  }, _vm._l((_vm.users), function(user) {
    return _c('li', {
      staticClass: "user",
      class: "color-" + user.color
    }, [_c('h6', [_vm._v(_vm._s(user.name))]), _c('p', [_vm._v(_vm._s(user.email))]), _c('p', [_vm._v(_vm._s(user.phone))])])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-43880d36!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SettingsList.vue
// module id = 55
// module chunks = 0